import { type ReactNode, useEffect } from 'react';

import { BRAND, BrandMark, pageTitle } from '@/components/Brand';
import { Card } from '@/design-system/patterns/Card';

/**
 * Moldura das telas de acesso fora do login (convite, senha nova): a marca, um card
 * central de até 440px e o rodapé — também em 360px.
 */
export default function AuthFrame({ title, children }: { title: string; children: ReactNode }) {
  useEffect(() => {
    document.title = pageTitle(title);
  }, [title]);

  return (
    <main className="flex min-h-dvh flex-col items-center gap-5.5 bg-page px-4 py-10 text-ink">
      <BrandMark size="sm" />
      <Card className="flex w-full max-w-110 flex-col gap-4.5 rounded-dialog p-6 shadow-dialog sm:p-8">
        {children}
      </Card>
      <p className="m-0 text-caption text-ink-placeholder">
        {BRAND.full} · {BRAND.tagline}
      </p>
    </main>
  );
}
